// utils.ts
export const pxToRem = (value: number | string | undefined): string | undefined => {
  const baseFontSize = 10; // При font-size: 62.5% базовый размер равен 10px

  if (value === undefined) {
    return undefined;
  }

  let numericValue: number;

  if (typeof value === "number") {
    numericValue = value;
  } else if (typeof value === "string") {
    // Удаляем пробелы и суффикс "px", если он присутствует
    const cleanedValue = value.trim().toLowerCase().replace("px", "");
    numericValue = parseFloat(cleanedValue);
    if (isNaN(numericValue)) {
      return "0rem";
    }
  } else {
    return "0rem";
  }

  return `${numericValue * 1 / baseFontSize}rem`;
};
